import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";
import {GalleryItemData} from "../../gallery-preview/gallery-item-data";

@Component({
  selector: 'brt-organization-trophies-overlay-header',
  templateUrl: './organization-trophies-overlay-header.component.html',
  styleUrls: ['./organization-trophies-overlay-header.component.scss']
})
export class OrganizationTrophiesOverlayHeaderComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input('completedTrophies') completedTrophies = 0;
  @Input('totalTrophies') totalTrophies = 0;
}
